@if (type() === 'input') {

  <div class="form-field">
    @if (label()) {
      <mat-label [class.label-required]="isRequired">{{ label() }}</mat-label>
    }
    <div class="date-field-container" [class.warn]="hasError" [class.disabled]="isDisabled()" (focusout)="onDateFieldBlur($event)">
      <div class="date-inputs">
        <input #dayInput
               type="text"
               inputmode="numeric"
               maxlength="2"
               placeholder="jj"
               [value]="dayValue()"
               (input)="onDayInput($event)"
               (focus)="onFieldFocus($event)"
               (keydown)="onDateKeydown($event, 'day')"
               [disabled]="isDisabled()">
        <span>/</span>
        <input #monthInput
               type="text"
               inputmode="numeric"
               maxlength="2"
               placeholder="mm"
               [value]="monthValue()"
               (input)="onMonthInput($event)"
               (focus)="onFieldFocus($event)"
               (keydown)="onDateKeydown($event, 'month')"
               [disabled]="isDisabled()">
        <span>/</span>
        <input #yearInput
               type="text"
               inputmode="numeric"
               maxlength="4"
               placeholder="aaaa"
               [value]="yearValue()"
               (input)="onYearInput($event)"
               (focus)="onYearFocus($event)"
               (click)="onYearClick($event)"
               (keydown)="onDateKeydown($event, 'year')"
               [disabled]="isDisabled()">
      </div>
      @if (!dateOnly()) {
        <div class="time-inputs">
          <input #hourInput
                 type="text"
                 inputmode="numeric"
                 maxlength="2"
                 placeholder="hh"
                 [value]="hourValue()"
                 (input)="onHourInput($event)"
                 (focus)="onFieldFocus($event)"
                 (keydown)="onTimeKeydown($event, 'hour')"
                 [disabled]="isDisabled()">
          <span>:</span>
          <input #minuteInput
                 type="text"
                 inputmode="numeric"
                 maxlength="2"
                 placeholder="mm"
                 [value]="minuteValue()"
                 (input)="onMinuteInput($event)"
                 (focus)="onFieldFocus($event)"
                 (keydown)="onTimeKeydown($event, 'minute')"
                 [disabled]="isDisabled()">
        </div>
      }
      <mat-icon class="cursor-pointer icon-input" #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu">
        calendar_month
      </mat-icon>
    </div>
  </div>

} @else if (type() === 'chips') {
  <div class="flex-row gap-16">
    <vl-chips
      [matMenuTriggerFor]="menu"
      iconRight="expand_more"
      [state]="buttonState()"
      (action)="menuTrigger.openMenu()"
      #menuTrigger="matMenuTrigger">
      {{ label() }}
    </vl-chips>
  </div>
}

<mat-menu #menu class="calendar-menu" (click)="$event.stopPropagation()">
  <div class="flex-col gap-16">
    <mat-calendar class="calendar-menu" [startAt]="selectedDate()" [(selected)]="selectedDate"
                  (selectedChange)="onDateSelected($event)"
                  (click)="onCalendarClick($event)"></mat-calendar>
    @if (!dateOnly()) {
      <div class="flex-row align-center w100 justify-center gap-8" (click)="$event.stopPropagation()">
        <div class="flex-col picker-container" (click)="$event.stopPropagation()">
          <mat-icon class="cursor-pointer" (click)="hourUp()">keyboard_arrow_up</mat-icon>
          <input matInput type="number" class="input-number text-center" [(ngModel)]="hour"
                 (keydown.tab)="$event.stopPropagation()">
          <mat-icon class="cursor-pointer" (click)="hourDown()">keyboard_arrow_down</mat-icon>
        </div>
        <div class="justify-center align-center">
          <span>:</span>
        </div>

        <div class="flex-col picker-container" (click)="$event.stopPropagation()">
          <mat-icon class="cursor-pointer" (click)="minuteUp()">keyboard_arrow_up</mat-icon>
          <input matInput type="number" class="input-number text-center" [(ngModel)]="minute"
                 (keydown.tab)="$event.stopPropagation()">
          <mat-icon class="cursor-pointer" (click)="minuteDown()">keyboard_arrow_down</mat-icon>
        </div>
      </div>
      <div class="w100 flex-row gap-4 justify-around">
        @if (this.value()) {
          <vl-big-button color="error" text="Désélectionner" (action)="onClear()"/>
        }
        <vl-big-button color="primary" text="Valider" (action)="onValid()"/>
      </div>
    }
  </div>
</mat-menu>

